import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { getMedicineNameStage, getNursesDiagnosisUsertaskproceed, getTestingstageTaskOnTask, setNursesDiagnosisUsertaskproceed } from '../../api/chatApi/chatApi'
import { useLocation } from 'react-router-dom';
import CustomButton from '../../components/common/CustomButton'
import CustomHeader1 from '../../components/common/CustomHeader1'
import Slot from '../../components/common/Slots/Slot'
import SlotContainerMasonry from '../../components/common/Slots/SlotContainerMasonry'
import MainLayout from '../../components/Layout/MainLayout'
import useDiagnosisTypes from '../../hooks/diagnosis/useDiagnosisTypes'
import { SagaActionType } from '../../store/sagas/sagaActions'
import { RoutePath } from '../../types'
import chatApi from '../../api/chatApi'
import TooltipAccordion from '../../components/TooltipAccordion' // TODO: привязать подсказки
import { usePointProcentStore } from './store'
import useTestingStage from '../../hooks/testingTask/useTestingStage';
import MainNursesDiagnosisField from '../../components/PageBlocks/NursesDiagnosis/MainNursesDiagnosisField';
import TooltipDialog from '../../components/common/TooltipDialog';
import useTooltipState from '../../hooks/useTooltipState';
import ChatTooltip from '../../components/Tooltips/ChatTooltip';

interface IStage {
  routePath: string;
  activeStage: number;
  code: string;
  legend_id?: number;
  routhPathCode: string;
}

interface Stage {
  routePath: string;
  activeStage: number;
  code: string;
  legend_id?: number;
  routhPathCode: string;
}

export default function NursesDiagnosisPage() {
  const asyncStateDiagnosisTypes = useDiagnosisTypes()
  const diagnosisTypes = asyncStateDiagnosisTypes?.value
  const [status, setStatus] = useState<boolean>(false) // TODO: оставлено для возможности проведения опросов (пилот)
  const [mainNursesDiagnosis, setMainNursesDiagnosis] = useState<any>()
  const [mainNursesDiagnosisProceed, setMainNursesDiagnosisProceed] = useState<any>()

  const getPointProcent = usePointProcentStore(state => state.getPoints)
  const [stages, setStages] = useState<IStage[]>([]);
  const { routePath, routhPathCode, activeStage } = useNextStagePath(stages);
  const dispatch = useDispatch()
  const history = useHistory()
  const testingStage = useTestingStage()
  const location = useLocation();
  const [readyToSendDiagnosis, setReadyToSendDiagnosis] = useState<boolean>(false)
  const [taskProceedToggle, setTaskProceedToggle] = useState<boolean>(false)
  const [manualActiveStage, setManualActiveStage] = useState(false)

  const saveMainNursesDiagnosis = (mainNursesDiagnosis) => {
    setMainNursesDiagnosis(mainNursesDiagnosis)
    setReadyToSendDiagnosis(true)
  }

  useEffect(() => {
    dispatch({ type: SagaActionType.START_LOAD_DIAGNOSIS_FOMRMS })
  }, [dispatch])


  async function getHistoryStage() {
    try {
      const res = await chatApi.getTestingStageHistory()
      const result = res.result.find((el) => el.activeStageId === 12)
      if (result && (!stages || (stages && stages.length === 0))) {
        setManualActiveStage(true)
      } else {
        setManualActiveStage(false)
      }
    } catch (error) {
      console.warn(error)
    }
  }

  async function setHistoryStage(testingStage) {
    try {
      const res = await chatApi.setTestingStageHistory(testingStage)
    } catch (error) {
      console.warn(error)
    }
  }

  useEffect(() => {
    getHistoryStage()
  }, [stages])


  async function fetchAllStages() {
    try {
      const result = await getTestingstageTaskOnTask();
      setStages(result.data.testingstage_task_on_task);
      const currentStage = result.data.testingstage_task_on_task.find((stage: Stage) => stage.routePath === '/nurses_diagnosis');
      setCurrentStage(currentStage)

    } catch (error) {
      console.error('Ошибка при загрузке этапов:', error);
    }
  }

  useEffect(() => {
    fetchAllStages();
  }, []);

  function useNextStagePath(stages) {
    const location = useLocation();
    const currentPath = location.pathname;
    if (!stages || stages.length === 0) {
      return { routePath: '', routhPathCode: '' };
    }
    const sortedStages = stages.sort((a, b) => a.activeStage - b.activeStage);
    const currentIndex = sortedStages.findIndex(stage => stage.routePath === currentPath);

    if (currentIndex !== -1 && currentIndex + 1 < sortedStages.length) {
      return {
        routePath: sortedStages[currentIndex + 1].routePath,
        routhPathCode: sortedStages[currentIndex + 1].routhPathCode,
        activeStage: sortedStages[currentIndex + 1].activeStage
      };
    }

    return { routePath: '', routhPathCode: '', activeStage: '' };
  }

  useEffect(() => {
    const getDialogStatus = async () => {
      try {
        const response = await chatApi.getSettingsPiloting();
        const statusValue = response?.result?.[0]?.value;
        setStatus(statusValue === 'true');
      } catch (error) {
        console.log('Не удалось получить настройки пилотинга', error)
        setStatus(false)
      }
    };

    void getDialogStatus();
  }, []);

  const [returnedStage, setReturnedStage] = useState<boolean>(false);

  function checkNextStage() {
    if (stages.length > 0) {
      const res = stages.find(el => el.routePath === location.pathname)
      let passedStage = 0
      if (res) {
        passedStage = stages.indexOf(res) + 1
      }
      if (testingStage > passedStage) {
        setReturnedStage(true)
      }
    }
  }

  useEffect(() => {
    checkNextStage()
  }, [activeStage])


  // Функция для перехода на следующий этап, если текущий этап уже пройден
  async function goToNextStage() {
    const currentPath = location.pathname;
    const currentStageObj = stages.find(stage => stage.routePath === currentPath);

    if (!currentStageObj) return;

    setHistoryStage(currentStageObj.activeStage);
    const currentActiveStage = currentStageObj.activeStage;

    const sortedNextStages = stages
      .filter(stage => stage.activeStage > currentActiveStage)
      .sort((a, b) => a.activeStage - b.activeStage);

    if (sortedNextStages.length === 0) {
      console.warn('Нет доступных следующих стадий.');
      return;
    }

    let nextIndex = 0;

    if (sortedNextStages[nextIndex].code === 'conclusion') {
      nextIndex += 1;

      if (nextIndex >= sortedNextStages.length) {
        nextIndex = 0;
      }
    }

    const finalNextStage = sortedNextStages[nextIndex];

    if (finalNextStage.legend_id) {
      history.push(RoutePath.legend);
    } else {
      history.push(finalNextStage.routePath);
    }
  }

  useEffect(() => {
    getPointProcent()
  }, [])

  const getTaskProceedData = async () => {
    try {
      const resultTaskProceedAll = await getNursesDiagnosisUsertaskproceed();

      if (resultTaskProceedAll.data.NursesDiagnosisUsertaskproceed !== null && resultTaskProceedAll.data.NursesDiagnosisUsertaskproceed.length > 0) {
        if (resultTaskProceedAll.data.NursesDiagnosisUsertaskproceed.length > 0) {
          setTaskProceedToggle(true);
        }

        const mainDiagnoses = resultTaskProceedAll.data.NursesDiagnosisUsertaskproceed;

        setMainNursesDiagnosisProceed(mainDiagnoses.map(diagnosis => ({
          nursesDiagnosis: diagnosis.diagnosis,
          nursesDiagnosisId: diagnosis.id
        })));
      }
    } catch (error) {
      console.warn(error);
    }
  };


  useEffect(() => {
    getTaskProceedData()
  }, [])


  const saveNursesDiagnosis = async () => {
    try {
      const allDiagnoses = [
        ...(mainNursesDiagnosis || []),
      ];


      const validDiagnoses = allDiagnoses.filter(diagnosis => diagnosis && diagnosis.nursesDiagnosisId);

      if (validDiagnoses.length === 0) {
        console.warn('Нет данных для сохранения');
        return;
      }


      await setNursesDiagnosisUsertaskproceed({
        value: validDiagnoses.map(diagnosis => diagnosis.nursesDiagnosisId)
      });
      console.warn('диагнозы успешно сохранены');
    } catch (error) {
      console.warn('Ошибка при сохранении диагнозов:', error);
    } finally {
      goToNextStage();
    }
  };

  const unfinishedTaskHandler = async () => {
    const response = await chatApi.unfinishedTask()
    setTaskId(response.result.taskId)
  }
  useEffect(() => {
    unfinishedTaskHandler()
  }, [])

  const taskName = '' // TODO: привязать ID задания

  const [tooltipState, openTooltip] = useTooltipState()

  const [tooltipText, setTooltipText] = useState<string>('')
  const [taskId, setTaskId] = useState<number>(0)
  const [currentStage, setCurrentStage] = useState<any>(null)

  async function getMedicineNameStages() {
    try {
      const result = await getMedicineNameStage({ task_id: taskId })

      if (result.data.MedicineNameStage && result.data.MedicineNameStage.length > 0 && currentStage) {
        const stageHintElement = result.data.MedicineNameStage.find(el => el.testingstage_id === currentStage.testingstage_id)
        setTooltipText(stageHintElement)
      }

    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getMedicineNameStages()
  }, [currentStage])

  return (
    <>
      {diagnosisTypes ? (
        <MainLayout
          // title='Диагноз медсестры'
          title='Предварительный диагноз'
          onClickTooltip={openTooltip}
        >

          {/* {open ? <RatingDialog open={open} onSubmit={hideRatingDialog} /> : null} */}
          <TooltipDialog {...tooltipState}>
            {currentStage && <ChatTooltip task_id={taskId} testingStageId={currentStage.testingstage_id} />}
          </TooltipDialog>
          {/* <TooltipAccordion taskName={taskName} /> */}

          <div style={{ paddingBottom: `25px`, overflowY: 'hidden', height: '90vh', display: 'flex', flexDirection: 'column' }}>
            {taskProceedToggle ?
              <React.Fragment>
                {/* <CustomHeader1>Диагноз медсестры уже отправлен</CustomHeader1> */}
                <CustomHeader1>Предварительный диагноз уже отправлен</CustomHeader1>
              </React.Fragment> :
              null}
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', flex: 1 }}>
              <div style={{ width: '95%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                {/* <SlotContainerMasonry> */}
                <div style={{ width: '100%', alignSelf: 'center', marginTop: '20px' }}>
                  <Slot title='Диагноз' color='primary'>
                    <MainNursesDiagnosisField
                      saveMainNursesDiagnosis={saveMainNursesDiagnosis}
                      initialDiagnosis={mainNursesDiagnosisProceed}
                      taskProceedToggle={taskProceedToggle}
                    />
                  </Slot>
                </div>
              </div>
            </div>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', padding: '20px 0' }}>
              {!taskProceedToggle ?
                <CustomButton
                  onClick={saveNursesDiagnosis}
                  disabled={!readyToSendDiagnosis}
                >
                  Завершить шаг
                </CustomButton> :
                <CustomButton
                  onClick={goToNextStage}
                >
                  Следующий этап
                </CustomButton>}
            </div>
          </div>
        </MainLayout>
      ) : (
        <p>Загрузка данных...</p>
      )}
    </>
  )
}


